import { render, staticRenderFns } from "./LanguagesIcon.vue?vue&type=template&id=7f67eadc&scoped=true"
var script = {}
import style0 from "./LanguagesIcon.vue?vue&type=style&index=0&id=7f67eadc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f67eadc",
  null
  
)

export default component.exports